export default "__VITE_ASSET__B_bFGRD0__"